export default __webpack_public_path__ + "static/media/headerimage.8ab8b5b6.jpg";